export enum endpoint {
  users = 'users-account',
  listUsers = 'get-list-users',
  createUser = 'create',
  deleteUser = 'delete',
  updateUser = 'update',
  disableUser = 'disable',
  enableUser = 'enable',
  dowloadCreateUserFormat = 'users-account/create-format',
  dowloadDisableFormat = 'users-account/disable-format',
  uploadCreateUser = 'users-account/create-massive',
  uploadDisableUser = 'users-account/disable-massive',
}
export interface UserData {
  user_id: number;
  user_name: string;
  user_lastname: string;
  user_email: string;
  user_identification: string;
  user_role_id: number;
  user_last_connection_date: Date | undefined;
  role_value: string;
  role_view_value_es: string;
  user_is_deleted: boolean;
  user_is_disabled: boolean;
  row_count: number;
  institutions: Institution[];
  user_language_id: number;
}

export interface Institution {
  institution_id: number;
  institution_name: string;
  dependence: string;
  work_position_id: number;
  user_disable_institution: boolean;
}

export interface UserSesionData {
  id: number;
  email: string;
  user_role_id: number;
  name: string;
  last_name: string;
  role_name: string | null;
  role_value: string;
  institutions: number[];
}

export enum UserStatus {
  Disabled = 'disabled',
  Enabled = 'enabled',
}

export interface ListUsersResponse {
  data: Data;
  message: string;
  code: number;
}

export interface Data {
  data: UserData[];
  totalItems: number;
  currentPage: number;
  totalPages: number;
}

export interface FormUserBody {
  role: string;
  name: string;
  lastname: string;
  email: string;
  language: { value: string; viewValue: string };
  identificationNumber: string;
  groupInstitutions: GroupInstitution[];
}

export interface GroupInstitution {
  institution: { value: string; viewValue: string };
  dependence: string;
  position: { value: string; viewValue: string };
}

export interface UpdateUser {
  userUpdate: UserBasicBody;
  userUInstitutions: UserUInstitution[];
}

export interface CreateUser {
  newUser: UserBasicBody;
  userInstitutions: UserUInstitution[];
}

export interface UserUInstitution {
  user_institution_institution_id: number;
  user_institution_user_work_position_id: number;
  user_institution_institution_dependence: string;
}

export interface UserBasicBody {
  user_role_id: number;
  user_name: string;
  user_lastname: string;
  user_identification: string;
  user_email: string;
  user_is_disabled?: number;
  user_language_id?: number;
}

export interface ResCreateUser {
  status?: string;
  message?: string;
  pswwd?: string;
}
export interface ResDeleteUser {
  status?: string;
  message?: string;
}

export interface EnableDisableUserResponse {
  data: string;
  message: string;
  code: number;
}

export interface GetUsersHttpParams {
  search?: string;
  user_role_id?: number;
  institution_id?: number[];
  page?: number;
  pageSize?: number;
  user_status?: string;
}

export const initialUser: UserData = {
  user_id: 0,
  user_name: '',
  user_lastname: '',
  user_email: '',
  user_identification: '',
  user_role_id: 0,
  user_last_connection_date: undefined,
  role_value: '',
  role_view_value_es: '',
  user_is_deleted: false,
  user_is_disabled: false,
  row_count: 0,
  institutions: [],
  user_language_id: 0,
};

export const initialSesionUser: UserSesionData = {
  id: 0,
  name: '',
  last_name: '',
  email: '',
  user_role_id: 0,
  role_value: '',
  role_name: '',
  institutions: [],
};
